import React from 'react';
import { CssBaseline } from '@material-ui/core';
import MenuPainel from '../components/MenuPainel';
import Formulario from '../components/Formulario';
import { ChangePassword } from '../components/ChangePassword';
import PaperForm from '../components/PaperForm';
import GlobalStyle from '../styles/globalStyle';

class Painel extends React.Component {
  render() {
    return (
      <React.Fragment>
        <CssBaseline />
        <GlobalStyle />
        <ChangePassword />
        <MenuPainel>
          <PaperForm
            title={''}
            margin={'15px 0'}
            elevation={24}
            componente={<Formulario />}
          ></PaperForm>
        </MenuPainel>
      </React.Fragment>
    );
  }
}

const connectedAssinar = Painel;
export { connectedAssinar as Painel };
